import ReactStrapTable from "components/reactStrapTable";
import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { dateFormate, currencyFormat, cellRendererCheck } from "utils/columns";
import CellOptions from "components/reactStrapTable/components/CellOptions";
import View from "assets/icon/icon-icon-options-view-patient.svg";
import ViewHover from "assets/icon/icon-icon-options-view-patient_hover.svg";
import Loader from "components/Loader";
import useAxios from "hooks/useAxios";
import CancleIcon from "assets/icon/icon-icon-options-not-eligible.svg";
import SaveIcon from "assets/icon/icon-icon-options-order-complete.svg";
import CancleHoverIcon from "assets/icon/icon-icon-options-not-eligible-hover.svg";
import SaveHoverIcon from "assets/icon/icon-icon-options-order-complete-hover.svg";
import CellEditRender from "components/reactStrapTable/components/CellEditRender";
import HoverImage from "react-hover-image/build";
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import { toast } from "react-toastify";
import moment from "moment";
import NDCAccumulationDetails from "pages/Accumulations/AccumulationsN";
import Drawer from "components/Drawer";
import { cloneDeep } from "lodash";
import { ModuleAccess } from "utils/moduleaccess";


let rowForEdit = {};

const QueueTable = (props) => {
  const {
    collapseSider,
    toggleSider,
    queueTableData,
    setQueueTableData,
    queueTotalrecords,
    queuesearch,
    loading,
    orgId,
    setLoading,
    refetch,
    onSearchColumnFilters = () => '',
    onPageChange,
    columnFilters,
    ishiddenflag,
    setIshiddenflag,
    resetFilterFlag,
    SetResetFilterFlag
  } = props;

  const API = useAxios();
  //  const [tableData, setTableData] = useState(dummyData);
  const [purschasehistory, setPurchaseHistory] = useState(false)
  const [accRowData, setAccRowData] = useState({});
  const [showWarning, setShowWarning] = useState('')
  const [minmumDate, setMinmumDate] = useState(null);
  const [bupperr, setBuppErr] = useState(false);
  const [originalData, setOriginalData] = useState({});
  const editRow = (rowData, isEdit = true) => {
    setShowWarning('');
    setBuppErr(false);
    if (isEdit == false) {
      setIshiddenflag(false);
    }
    let tempData = [...queueTableData];
    if (isEdit) {
      let formattedRowData = { ...rowData };
      if (rowData.startDate) {
        const date = dateFormate(rowData.startDate);
        formattedRowData.startDate = date;
      }
      setOriginalData(formattedRowData);
    }
    tempData = tempData.map((row) => {
      row.isEdit = false;
      if (row.crosswalkQueueID == rowData?.crosswalkQueueID && isEdit) {
        row.isEdit = isEdit;
        // row.endDate=dateFormate(row.endDate)
        rowForEdit = row;
        // fetchActiveCharge(rowData)
      }
      return row;

    });
    setQueueTableData(tempData);
  };
  // const fetchActiveCharge = async (row) => {
  //   debugger;

  //   //setLoading(tr);
  //   try {
  //     const { data } = await API.get(
  //       `SBTenant/${orgId.tenantID}/Crosswalk/activeChargeCode/${row?.chargeCode}/${row?.accumulatorID}`,
  //       {
  //         hasDefaultURL: true,
  //       }
  //     );
  //     debugger;
  //     if (data) {
  //       debugger
  //       if (data.endDate == null) {
  //         setMinmumDate(data.startDate)
  //       }
  //       else {
  //         setMinmumDate(data.endDate)
  //       }


  //     }
  //     else {
  //       //  setLoading(false);
  //     }
  //   } catch {
  //     //setLoading(false);
  //   }
  // }
useEffect(()=>{
  setPurchaseHistory(false)
},[orgId])

  const saveUpdateRow = async () => {
    debugger;
    setIshiddenflag(false);
    let payload = { ...rowForEdit };
    payload.startDate = payload.startDate != null ? dateFormate(payload.startDate) : null;
    if (payload.bupp == "0" || payload.bupp == "" || payload.bupp == null) {
      setBuppErr(true);
      if (payload.startDate == null) {
        return setShowWarning('Effective Date is required')
      }
      return true;
    }
    if (payload.startDate == null) {
      return setShowWarning('Effective Date is required')
    }
    setLoading(true)
    payload.startDate = moment(payload.startDate, "MM/DD/YYYY").format("YYYY-MM-DD[T]HH:mm:ss");
    delete payload.isEdit;
    try {
      const result = await API.post(
        `SBTenant/${orgId.tenantID}/Crosswalk/UpdateCrossWalkQueue`,
        payload,
        {
          hasDefaultURL: true,
        }
      );

      if (result.data == true) {
        toast.success('updated successfully');
        refetch(true);
        setLoading(false);
      }
      else {
        setLoading(false);
      }
    } catch {
      setLoading(false);
    }
  };
  const hasPermission = (code) => {
    return ModuleAccess("CRW", code);
  };
  const cellRenderEdit = (row) => {
    if (hasPermission("ED"))
      return <CellOptions row={row} onEdit={editRow} onSave={saveUpdateRow} ishiddenflag={ishiddenflag} setIshiddenflag={setIshiddenflag} />;
  };

  const isEqual = (a, b) => {
    const normalize = val => (val === null || val === undefined || val === "") ? "" : val;
    return normalize(a).toString() === normalize(b).toString();
  }

  const updateRowValue = (value, col) => {
    debugger;
    if (col === 'startDate' && value != "") {
      setShowWarning('')
    }

    const tempRow = { ...rowForEdit };
    if (rowForEdit.startDate) {
      tempRow.startDate = dateFormate(rowForEdit.startDate);
    }

    tempRow[col] = value;
    const isSame =
      isEqual(originalData.bupp, tempRow.bupp) &&
      isEqual(originalData.startDate, tempRow.startDate) &&
      isEqual(originalData.notes, tempRow.notes);
      setIshiddenflag(!isSame);
    rowForEdit = tempRow;

  };

  const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {
    if (formatterType == "date") {
      return (
        <CellEditRender
          row={row}
          col={col}
          formatterType={formatterType}
          onChange={updateRowValue}
          // hasTouched={true}
          crosswalktab='crosswalkQueue'
          showWarning={showWarning}
          endDateFormatter={true}
          alwaysEditableCheckbox={alwaysEditableCheckbox}

        />
      );
    }
    else {
      return (
        <CellEditRender
          row={row}
          col={col}
          // hasTouched={true}
          formatterType={formatterType}
          wacErr={bupperr}
          onChange={updateRowValue}
          showWarning={showWarning}
          crosswalktab='crosswalkQueue'
        // alwaysEditableCheckbox={alwaysEditableCheckbox}
        />
      );
    }
  };

  let mainCol = [
    {
      dataField: "edit",
      text: "Options",
      cellRenderer: (rowData) => cellRenderEdit(rowData),
      width: 117,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: "chargeCode",
      text: "Charge Code",
      //sort: true,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.chargeCode),
    },
    {
      dataField: "chargeDescription",
      text: "Charge Description",
      // sort: false,
      width: 240,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.chargeDescription),
    },
    {
      dataField: "ndc",
      text: "NDC",
      sort: true,
      width: 180,
      show: true,
      inputType: "text",

      hideColFilter: false,
      cellRenderer: (row) => cellRenderLink(row),
    },
    {
      dataField: "drugName",
      text: "NDC Description",
      sort: true,
      width: 240,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.drugName),
    },
    {
      dataField: "packageSize",
      text: "Package Size",
      sort: true,
      width: 140,
      show: true,
      inputType: "number",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.packageSize),
    },
    {
      dataField: "bupp",
      text: "BUPP",
      sort: false,
      width: 100,
      show: true,
      edit: true,
      inputType: "number",
      hideColFilter: true,
      cellRenderer: (row, col) => formatter(row, col, 'number'),
    },
    {
      dataField: "startDate",
      text: "Effective Date",
      sort: false,
      width: 160,
      show: true,
      edit: true,
      inputType: "date",
      hideColFilter: true,
      cellRenderer: (row, col) => formatter(row, col, "date"),
    },
    // {
    //   dataField: "note",
    //   text: "Note",
    //   //sort: true,
    //   width: 140,
    //   show: true,
    //   inputType: "text",
    //   hideColFilter: false,
    //   cellRenderer: (row) => cellRendererCheck(row.note),
    // },
    // {
    //   dataField: "reason",
    //   text: "Reason",
    //   //sort: true,
    //   width: 140,
    //   show: true,
    //   inputType: "text",
    //   hideColFilter: false,
    //   cellRenderer: (row) => cellRendererCheck(row.reason),
    // },
    {
      dataField: "note",
      text: "Comments",
      sort: false,
      edit: true,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row, col) => formatter(row, col, 'text'),
    },
    {
      dataField: "modifiedByID",
      text: "Modified By ",
      //sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.modifiedByID),
    },
    {
      dataField: "modifiedDate",
      text: "Modified Date",
      sort: true,
      width: 160,
      show: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (row) => dateFormate(row.modifiedDate),
    }
  ];

  const handelPurchaseHistory = (rowData) => {
    setPurchaseHistory(!purschasehistory)
    setAccRowData(rowData)

  }
  const cellRenderLink = (row) => {
    return (
      <>
        <span
          className='text-decoration-underline d-inline-block cursor-pointer'
          onClick={() => handelPurchaseHistory(row)}
        >
          {row.ndc}
        </span>
      </>
    )
  }

  const onHandleSort = (filter, hasColFilter) => {
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };
  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {

    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    onPageChange(filter);
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {

    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      onPageChange(filter);
    }
  };
  const handleFilterCancel = () => {
    refetch(true);
  };
  const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
      onSearchColumnFilters(colFilter);
      // setColFilters(colFilter);
    }
  };
  const handleExport = async () => {
    debugger;
    const filterObj = cloneDeep(queuesearch);
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
    }
    const { access_token } =
      JSON.parse(localStorage.getItem('pharmaforce')) || {};

    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
    additionalCriteria.OrgId = orgId.organizationID;
    var payload = {};
    payload.tenantID = orgId.tenantID
    payload.gridCode = "crosswalkQueue";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  };
  return (
    <div>
      {/* {loading && <Loader opacity={0.01} />} */}
      <h5 className="f-18 text-primary font-weight-600">
        Crosswalk Queue ({queueTotalrecords})
      </h5>
      <hr />
      <div
        className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={
          queueTableData.length > 0
            ? `${collapseSider ? "collapse-fixed-height" : "fixed-height"}`
            : "default"
        }
      >
        <ReactStrapTable
          id="crosswalk-queue-table"
          height={550}
          fixedColumn
          width={1200}
          // reset={reset}
          hasPagination
          data={queueTableData}
          columns={mainCol}
          onExport={handleExport}
          filters={queuesearch}
          totalRecords={queueTotalrecords}
          pageSize={queuesearch.pageSize}
          currentPage={queuesearch.currentPage}
          handleSort={onHandleSort}
          onPageChange={onHandlePageChange}
          onPageSizeChange={onPageSizeChange}
          onFilterCancel={handleFilterCancel}
          onSearchColumnFilters={handleSearchColumnFilters}
          //accuntErr={accuntErr}
          collapseSider={collapseSider}
          toggleSider={toggleSider}
          showtoggle={true}
        resetFilterFlag={resetFilterFlag}
        SetResetFilterFlag={SetResetFilterFlag}
        />
      </div>

      <Drawer
        direction="end"
        title="Purchase History"
        isOpen={purschasehistory}
        toggle={handelPurchaseHistory}
        size="lg"
      >
        <NDCAccumulationDetails tenantID={orgId} rowData={accRowData} onClose={handelPurchaseHistory} />
      </Drawer>


    </div>

  );
};

export default QueueTable;
